import React from 'react';
import { Button, Header, Segment, Table, Loader, Icon, Popup, Grid, SegmentGroup } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment-business-days';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
// eslint-disable-next-line import/first
import download from 'downloadjs';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


const NoDataMessage = () => <p><FormattedMessage id="professorInputGrades.NoDataMessage" /></p>;


export default class SelectCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            professorId: '',
            loading: true,
        };

        this.fetchCourses = this.fetchCourses.bind(this);
        this.onCourseSelected = this.onCourseSelected.bind(this);
        this.getStudents = this.getStudents.bind(this);
        this.getStudentGrades = this.getStudentGrades.bind(this);
    }

    componentDidMount() {
        this.fetchCourses();
        if (this.props.finalized) { toast(<FormattedMessage id="professorInputGrades.toastFinalized" />); }

        if (this.props.msg === '/aktivni-ispiti' || this.props.msg === undefined) {
            localStorage.setItem('path', '/aktivni-ispiti/unos-ocjena/podaci-o-studentu');
        } else {
            localStorage.setItem('path', '/active-exams/input-grades/student-info');
        }
    }


    onCourseSelected(courseImplementationId, gradedActivityId, gradedActivityName, courseImplementationName, date) {
    }


    fetchCourses() {
        let obj = {};
        axios.post(`/professor/graded-activities/false/${window.$locale}`, { ...obj })
            .then(res => {
                const data = res.data.map(el => ({
                    ...el,
                    date: moment(el.gradedActivityDate).format('D. M. YYYY. - HH:mm'),
                }));
                this.setState({ data, loading: false });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch courses');
            });
    }

    getStudents(gradedActivityId) {
        let obj = {
            gradedActivityId,
            language: 'bs'
        };
        axios({
            method: 'post',
            url: '/documents/graded-activity-students',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }

    getStudentGrades(gradedActivityId) {
        let obj = {
            gradedActivityId,
            language: 'bs'
        };
        axios({
            method: 'post',
            url: '/documents/exam-marks-without-fullname',
            responseType: 'blob',
            data: { ...obj }
        })
            .then(res => {
                if (res.data.size === 0) {
                    return;
                }
                const fileName = extractFileNameFromHeaders(res.headers);
                download(res.data, fileName);
                return res;
            })
            .catch(err => {
                toast('Došlo je do greške! Zahtjev nije obrađen.');
            });
    }


    render() {
        const { data } = this.state;
        return (

            this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div> :
                this.props.noSegment ?
                    data.length ?
                        <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width="1">
                                        <FormattedMessage id="common.ordinal" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell colSpan="2">
                                        <FormattedMessage id="common.courseName" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="professorInputGrades.examType" />
                                        <div style={{
                                            fontSize: '0.85em',
                                            color: '#999'
                                        }}>
                                            <FormattedMessage id="professorInputGrades.methodName" />
                                        </div>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        <FormattedMessage id="professorInputGrades.examDateDate" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell >
                                        <FormattedMessage id="professorInputGrades.examFinalizationTime" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="professorInputGrades.finalizationCancelDate" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <FormattedMessage id="common.courseRoleType" />
                                    </Table.HeaderCell>
                                    <Table.HeaderCell width={2} />
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {data.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell width="1" verticalAlign="middle">
                                        {index + 1}.
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" colSpan="2">
                                        <Grid columns={1} centered className="stackable">
                                            <Grid.Row verticalAlign="middle">
                                                <Grid.Column width="10">
                                                    {el.courseImplementationName}
                                                </Grid.Column>
                                                <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                    <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.gradedActivityName}
                                        <div style={{
                                            fontSize: '0.85em',
                                            color: '#999'
                                        }}>
                                            {el.gradingMethodName ? el.gradingMethodName : ''}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.date}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" style={{ color: 'red' }}>
                                        {/* {moment(el.gradedActivityDate).businessAdd(10).format('D. M. YYYY.')} - 00:00 */}
                                        {el.finalizationCancelDate !== null
                                            ? moment(el.finalizationCancelDate)
                                                .add(3, 'days')
                                                .set({
                                                    hour: 0, minute: 0, second: 0, millisecond: 0
                                                })
                                                .subtract(1, 'minute')
                                                .format('D. M. YYYY.') + ' - 23:59'
                                            : moment(el.gradedActivityDate)
                                                .businessAdd(10)
                                                .set({
                                                    hour: 0, minute: 0, second: 0, millisecond: 0
                                                })
                                                .subtract(1, 'minute')
                                                .format('D. M. YYYY.') + ' - 23:59'
                                        }
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.finalizationCancelDate ? moment(el.finalizationCancelDate).format('D. M. YYYY.') + '\n' : ''}
                                        {el.documentNumber ? ' (Odluka: ' + el.documentNumber + ')' : ''}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.courseRoleTypeName || '-'}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle" >
                                        {localStorage.getItem('activeRole').substr(0, 8) === 'Profesor' && ((el.leadStaff) || (!el.leadStaff && el.courseImplementationHasGroups) || (!el.leadStaff && el.courseRoleTypeName === 'predsjednik komisije')) && <FormattedMessage id="route.inputGrades">
                                            {(msg) => (<Link to={{
                                                pathname: msg,
                                            }}
                                            >
                                                <Popup
                                                    content={<FormattedMessage id="professorInputGrades.gradeStudents" />}
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            onClick={() => {
                                                                localStorage.setItem('courseImplementationId', el.courseImplementationId);
                                                                localStorage.setItem('gradedActivityId', el.gradedActivityId);
                                                                localStorage.setItem('gradedActivityName', el.gradedActivityName);
                                                                localStorage.setItem('courseImplementationName', el.courseImplementationName);
                                                                localStorage.setItem('date', el.date);
                                                            }}
                                                            icon="tasks"
                                                            size="small"
                                                            color="blue"
                                                        >
                                                        </Button>
                                                    }
                                                />
                                                {/* <Button */}
                                                {/*    basic="true" */}
                                                {/*    color="blue" */}
                                                {/*    onClick={() => { */}
                                                {/*        localStorage.setItem('courseImplementationId', el.courseImplementationId); */}
                                                {/*        localStorage.setItem('gradedActivityId', el.gradedActivityId); */}
                                                {/*        localStorage.setItem('gradedActivityName', el.gradedActivityName); */}
                                                {/*        localStorage.setItem('courseImplementationName', el.courseImplementationName); */}
                                                {/*        localStorage.setItem('date', el.date); */}
                                                {/*    }} */}
                                                {/* > */}
                                                {/*    <FormattedMessage id="professorInputGrades.gradeStudents" /> */}
                                                {/* </Button> */}
                                            </Link>)}</FormattedMessage>}

                                        <Popup
                                            content={<FormattedMessage id="professorInputGrades.printStudentsList" />}
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    onClick={() => this.getStudents(el.gradedActivityId)}
                                                    icon="print"
                                                    size="small"
                                                    color="teal"
                                                >
                                                </Button>
                                            }
                                        />
                                    </Table.Cell>

                                </Table.Row>))}
                            </Table.Body>
                        </Table>

                        : <NoDataMessage /> :

                        <SegmentGroup raised>
                        <Segment>
                                <Header as="h3">
                                <FormattedMessage id="professorInputGrades.activeExamsList" />
                            </Header>
                            </Segment>
                        <Segment>
                                {
                                data.length ?
                                    <Table celled selectable compact>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell width="1">
                                                    <FormattedMessage id="common.ordinal" />
                                                </Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2">
                                                    <FormattedMessage id="common.courseName" />
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    <FormattedMessage id="professorInputGrades.examType" />
                                                    <div style={{
                                                        fontSize: '0.85em',
                                                        color: '#999'
                                                    }}>
                                                        <FormattedMessage id="professorInputGrades.methodName" />
                                                    </div>
                                                </Table.HeaderCell>
                                                <Table.HeaderCell >
                                                    <FormattedMessage id="professorInputGrades.examDateDate" />
                                                </Table.HeaderCell>
                                                <Table.HeaderCell >
                                                    <FormattedMessage id="professorInputGrades.examFinalizationTime" />
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    <FormattedMessage id="professorInputGrades.finalizationCancelDate" />
                                                </Table.HeaderCell>
                                                <Table.HeaderCell>
                                                    <FormattedMessage id="common.courseRoleType" />
                                                </Table.HeaderCell>
                                                <Table.HeaderCell width={2} />
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body> {data.map((el, index) =>
                                            (<Table.Row key={index}>
                                                <Table.Cell width="1" verticalAlign="middle">
                                                    {index + 1}.
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" colSpan="2">
                                                    <Grid columns={1} centered className="stackable">
                                                        <Grid.Row verticalAlign="middle">
                                                            <Grid.Column width="10">
                                                                {el.courseImplementationName}
                                                            </Grid.Column>
                                                            <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                                <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    </Grid>
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.gradedActivityName}
                                                    <div style={{
                                                        fontSize: '0.85em',
                                                        color: '#999'
                                                    }}>
                                                        {el.gradingMethodName ? el.gradingMethodName : ''}
                                                    </div>
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle">
                                                    {el.date}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" style={{ color: 'red' }}>
                                                    {el.finalizationCancelDate !== null
                                                        ? moment(el.finalizationCancelDate)
                                                            .add(3, 'days')
                                                            .set({
                                                                hour: 0, minute: 0, second: 0, millisecond: 0
                                                            })
                                                            .subtract(1, 'minute')
                                                            .format('D. M. YYYY.') + ' - 23:59'
                                                        : moment(el.gradedActivityDate)
                                                            .businessAdd(10)
                                                            .set({
                                                                hour: 0, minute: 0, second: 0, millisecond: 0
                                                            })
                                                            .subtract(1, 'minute')
                                                            .format('D. M. YYYY.') + ' - 23:59'
                                                    }
                                                </Table.Cell>

                                                {/* <Table.Cell verticalAlign="middle" style={{ color: 'red' }}> */}
                                                {/*    /!*{moment(el.gradedActivityDate).businessAdd(10).format('D. M. YYYY.')} - 00:00*!/ */}
                                                {/* </Table.Cell> */}
                                                <Table.Cell verticalAlign="middle">
                                                    {el.finalizationCancelDate ? moment(el.finalizationCancelDate).format('D. M. YYYY.') + '\n' : ''}
                                                    {el.documentNumber ? ' (Odluka: ' + el.documentNumber + ')' : ''}
                                                </Table.Cell>
                                                <Table.Cell>
                                                    {el.courseRoleTypeName || '-'}
                                                </Table.Cell>
                                                <Table.Cell textAlign="center" verticalAlign="middle" >
                                                    {localStorage.getItem('activeRole').substr(0, 8) === 'Profesor' && ((el.leadStaff) || (!el.leadStaff && el.courseImplementationHasGroups) || (!el.leadStaff && el.courseRoleTypeName === 'predsjednik komisije')) && <FormattedMessage id="route.inputGrades">
                                                        {(msg) => (<Link to={{
                                                            pathname: msg,
                                                        }}
                                                        >
                                                            <Popup
                                                                content={<FormattedMessage id="professorInputGrades.gradeStudents" />}
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        basic="true"
                                                                        circular
                                                                        onClick={() => {
                                                                            localStorage.setItem('courseImplementationId', el.courseImplementationId);
                                                                            localStorage.setItem('gradedActivityId', el.gradedActivityId);
                                                                            localStorage.setItem('gradedActivityName', el.gradedActivityName);
                                                                            localStorage.setItem('courseImplementationName', el.courseImplementationName);
                                                                            localStorage.setItem('date', el.date);
                                                                        }}
                                                                        icon="tasks"
                                                                        size="small"
                                                                        color="blue"
                                                                    >
                                                                    </Button>
                                                                }
                                                            />
                                                            {/* <Button */}
                                                            {/*    basic="true" */}
                                                            {/*    color="blue" */}
                                                            {/*    onClick={() => { */}
                                                            {/*        localStorage.setItem('courseImplementationId', el.courseImplementationId); */}
                                                            {/*        localStorage.setItem('gradedActivityId', el.gradedActivityId); */}
                                                            {/*        localStorage.setItem('gradedActivityName', el.gradedActivityName); */}
                                                            {/*        localStorage.setItem('courseImplementationName', el.courseImplementationName); */}
                                                            {/*        localStorage.setItem('date', el.date); */}
                                                            {/*    }} */}
                                                            {/* > */}
                                                            {/*    <FormattedMessage id="professorInputGrades.gradeStudents" /> */}
                                                            {/* </Button> */}
                                                        </Link>)}</FormattedMessage>}

                                                    <Popup
                                                        content={<FormattedMessage id="professorInputGrades.printStudentsList" />}
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic="true"
                                                                circular
                                                                onClick={() => this.getStudents(el.gradedActivityId)}
                                                                icon="print"
                                                                size="small"
                                                                color="teal"
                                                            >
                                                            </Button>
                                                        }
                                                    />

                                                    {localStorage.getItem('activeRole').substr(0, 8) === 'Asistent' && <Popup
                                                        content={<FormattedMessage id="professorInputGrades.printGradesList" />}
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic="true"
                                                                circular
                                                                onClick={() => this.getStudentGrades(el.gradedActivityId)}
                                                                icon="file pdf outline"
                                                                size="small"
                                                                color="red"
                                                            >
                                                            </Button>
                                                        }
                                                    />}
                                                </Table.Cell>

                                            </Table.Row>))}
                                        </Table.Body>
                                    </Table>

                                    : <NoDataMessage />

                            }
                            </Segment>
                        <ToastContainer hideProgressBar />
                    </SegmentGroup>


        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/SelectCourse.js